'use client'

import type { EIP1193Provider } from 'viem'

/**
 * Global registry key for a caller-selected EIP-1193 provider.
 * @internal
 */
export const EXPLICIT_INJECTED_PROVIDER_KEY = '@repo/web3/explicit-injected-provider'

/**
 * Install the EIP-1193 provider used by the explicit connector.
 * Used by the development-only sandbox wallet artifact.
 */
export function registerExplicitInjectedProvider(provider: EIP1193Provider): void {
  Reflect.set(globalThis, Symbol.for(EXPLICIT_INJECTED_PROVIDER_KEY), provider)
}

/** Read the explicitly registered EIP-1193 provider, if one has been installed. */
export function getExplicitInjectedProvider(): EIP1193Provider | undefined {
  const provider: unknown = Reflect.get(globalThis, Symbol.for(EXPLICIT_INJECTED_PROVIDER_KEY))
  if (!isEip1193Provider(provider)) return undefined
  return provider
}

function isEip1193Provider(value: unknown): value is EIP1193Provider {
  if (typeof value !== 'object' || value === null) return false
  const candidate = value as Record<string, unknown>
  return (
    typeof candidate.request === 'function' &&
    typeof candidate.on === 'function' &&
    typeof candidate.removeListener === 'function'
  )
}
